import React, { useState } from 'react'
import { useTimer, useTypedSelector } from '../../hooks'
import GameWinMessage from './GameWinMessage'
import GameControlBar from './GameControlBar'
import GameContext from './GameContext'
import { Container } from './styles'
import GameCards from './GameCards'
import { initialCard, CardType } from './types'

const Game: React.FC = () => {
  const [iconList, setIconList] = useState<CardType[]>([])
  const [iconFoundList, setIconFoundList] = useState<CardType[]>([])
  const [firstSelectedCard, setFirstSelectedCard] = useState(initialCard)
  const [secondSelectedCard, setSecondSelectedCard] = useState(initialCard)
  const [isShowingWinModal, setIsShowingWinModal] = useState(false)
  const [isCheckingCards, setIsCheckingCards] = useState(false)
  const [isPaused, setIsPaused] = useState(true)
  const [isCheckWin, setIsCheckWin] = useState(true)

  const { difficulty } = useTypedSelector(({ GameConfig }) => GameConfig)

  const {
    hoursText,
    minutesText,
    secondsText,
    onStartTimer,
    onStopTimer,
    onPauseTimer,
  } = useTimer()

  return (
    <GameContext.Provider
      value={{
        difficulty,
        isPaused,
        setIsPaused,
        iconList,
        setIconList,
        iconFoundList,
        setIconFoundList,
        firstSelectedCard,
        setFirstSelectedCard,
        secondSelectedCard,
        setSecondSelectedCard,
        isCheckingCards,
        setIsCheckingCards,
        isShowingWinModal,
        setIsShowingWinModal,
        isCheckWin,
        setIsCheckWin,
        hoursText,
        minutesText,
        secondsText,
        onStartTimer,
        onStopTimer,
        onPauseTimer,
      }}
    >
      <Container>
        <GameCards />
        <GameControlBar />
        <GameWinMessage />
      </Container>
    </GameContext.Provider>
  )
}

export default Game
